export default "__VITE_ASSET__C_7XK5dT__"